module.exports = __webpack_public_path__ + "static/3-d09cde1dc70be9130839defa27d06aa0.jpeg";